import styled from "styled-components";
import { mediaMax } from "helpers/mediaQueries";

export const FullScreenImageSection = styled.section`
  position: relative;
  background-color: transparent;
  &.parallax-image {
    transform: translateY(-100%);
  }
  ${mediaMax("desktopSm")} {
    &.parallax-image {
      transform: none;
    }
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  height: 100vh;
  .gatsby-image-wrapper {
    height: 100%;
    width: 100%;
  }
  ${mediaMax("tabletLandscape")} {
    height: auto;
  }
`;
